var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.866,
    height: 54.91,
    viewBox: "0 0 157.866 54.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-97.781 -319.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subtitel",
    transform: "translate(156.348 356.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M179.289,375.634c-.013.02-.032.046-.057.081a2.176,2.176,0,0,1-.179.191,1.721,1.721,0,0,1-.307.24,1.906,1.906,0,0,1-.44.186,1.984,1.984,0,0,1-.574.083,2.067,2.067,0,0,1-1.541-.683,2.435,2.435,0,0,1,0-3.319,2.065,2.065,0,0,1,1.543-.683,2.035,2.035,0,0,1,.569.078,1.646,1.646,0,0,1,.445.2,2.336,2.336,0,0,1,.3.236,1.676,1.676,0,0,1,.183.2l.057.076v-.681h.686v4.391a2.274,2.274,0,0,1-.67,1.662,2.2,2.2,0,0,1-1.626.676,2.425,2.425,0,0,1-.707-.1,2.172,2.172,0,0,1-.55-.243,3.536,3.536,0,0,1-.379-.283,1.421,1.421,0,0,1-.236-.248l-.076-.1.438-.438c.013.019.034.047.064.083a2.365,2.365,0,0,0,.191.191,2.075,2.075,0,0,0,.307.238,1.865,1.865,0,0,0,.419.186,1.7,1.7,0,0,0,.529.084,1.524,1.524,0,0,0,1.136-.491,1.677,1.677,0,0,0,.474-1.214Zm-2.612-.352a1.405,1.405,0,0,0,1.055.495,1.456,1.456,0,0,0,1.1-.49,1.828,1.828,0,0,0,0-2.429,1.456,1.456,0,0,0-1.1-.49,1.4,1.4,0,0,0-1.055.5,1.822,1.822,0,0,0,0,2.419Z",
    transform: "translate(-175.536 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M186.183,374.415a1.685,1.685,0,0,0,1.657,1.557,1.739,1.739,0,0,0,.814-.2,1.672,1.672,0,0,0,.533-.39l.166-.191.438.438c-.019.026-.047.062-.084.108a2.424,2.424,0,0,1-.238.234,2.519,2.519,0,0,1-.395.29,2.666,2.666,0,0,1-.548.234,2.243,2.243,0,0,1-.688.107,2.217,2.217,0,0,1-1.648-.712,2.512,2.512,0,0,1-.007-3.453,2.213,2.213,0,0,1,3.207-.047,2.316,2.316,0,0,1,.643,1.679l-.048.352Zm.538-1.615a1.7,1.7,0,0,0-.538,1.029h3.171a1.676,1.676,0,0,0-.511-1.048,1.469,1.469,0,0,0-1.05-.414A1.51,1.51,0,0,0,186.72,372.8Z",
    transform: "translate(-177.995 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M195.877,369.788h.633v1.562h1.024v.633H196.51v2.781q0,.733.633.728a1.291,1.291,0,0,0,.312-.038c.1-.026.182-.047.236-.067l.086-.038v.633a1.407,1.407,0,0,1-.662.142,1.248,1.248,0,0,1-.945-.355,1.393,1.393,0,0,1-.34-1.007v-2.781h-.881v-.633h.538q.391,0,.391-.486Z",
    transform: "translate(-180.326 -369.107)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M208.7,376.543l-1.9-4.681h.734l1.514,3.8,1.51-3.8h.733l-2.147,5.362a2.9,2.9,0,0,1-.624,1.054,1.181,1.181,0,0,1-.838.313,1.883,1.883,0,0,1-.3-.024,1.058,1.058,0,0,1-.216-.053l-.067-.019v-.638a1.4,1.4,0,0,0,.486.1.924.924,0,0,0,.881-.734Z",
    transform: "translate(-183.249 -369.619)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    d: "M216.683,372.436a2.377,2.377,0,0,1,3.383,0,2.506,2.506,0,0,1,0,3.465,2.384,2.384,0,0,1-3.383,0,2.5,2.5,0,0,1,0-3.465Zm2.9.452a1.653,1.653,0,0,0-2.41,0,1.879,1.879,0,0,0,0,2.558,1.648,1.648,0,0,0,2.41,0,1.885,1.885,0,0,0,0-2.562Z",
    transform: "translate(-185.518 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    d: "M229.817,375.91c-.013.019-.032.045-.057.078a1.682,1.682,0,0,1-.179.176,1.994,1.994,0,0,1-.3.224,1.766,1.766,0,0,1-.426.174,1.969,1.969,0,0,1-.545.076,1.8,1.8,0,0,1-1.36-.569,2.061,2.061,0,0,1-.541-1.479v-2.729h.682v2.729a1.411,1.411,0,0,0,.38,1.014,1.241,1.241,0,0,0,.934.4,1.321,1.321,0,0,0,1-.438,1.576,1.576,0,0,0,.41-1.119v-2.586h.685v4.681h-.685Z",
    transform: "translate(-188.09 -369.619)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    d: "M238.88,372.414h-.3a1.425,1.425,0,0,0-1.033.42,1.454,1.454,0,0,0-.429,1.091v2.586h-.682v-4.681h.682v.633c.012-.02.032-.046.057-.079a1.661,1.661,0,0,1,.182-.176,2,2,0,0,1,.307-.224,1.914,1.914,0,0,1,.438-.176,2.109,2.109,0,0,1,.578-.078h.2Z",
    transform: "translate(-190.566 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    d: "M250.172,371.761h-1.124v4.048h-.681v-4.048h-.734v-.633h.734v-.877a1.418,1.418,0,0,1,.335-1.009,1.217,1.217,0,0,1,.932-.357,1.587,1.587,0,0,1,.347.038,1.486,1.486,0,0,1,.257.076l.077.034v.633a1.376,1.376,0,0,0-.633-.148q-.634,0-.633.733v.877h1.124Z",
    transform: "translate(-193.328 -368.884)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    "data-name": "path",
    d: "M255.129,372.436a2.377,2.377,0,0,1,3.383,0,2.506,2.506,0,0,1,0,3.465,2.384,2.384,0,0,1-3.383,0,2.5,2.5,0,0,1,0-3.465Zm2.9.452a1.653,1.653,0,0,0-2.41,0,1.879,1.879,0,0,0,0,2.558,1.648,1.648,0,0,0,2.41,0,1.885,1.885,0,0,0,0-2.562Z",
    transform: "translate(-195.006 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-10",
    "data-name": "path",
    d: "M265.91,376.543l-1.9-4.681h.733l1.515,3.753,1.509-3.753h.734l-1.9,4.681Z",
    transform: "translate(-197.368 -369.619)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    "data-name": "path",
    d: "M276.371,373.534a1.134,1.134,0,0,0-.328-.843,1.15,1.15,0,0,0-.844-.324,1.493,1.493,0,0,0-.7.169,1.543,1.543,0,0,0-.474.345l-.148.166-.438-.438c.02-.026.045-.058.079-.1a2.448,2.448,0,0,1,.218-.209,2.885,2.885,0,0,1,.356-.27,2,2,0,0,1,.488-.212,2.09,2.09,0,0,1,.616-.093,1.811,1.811,0,0,1,1.326.519,1.732,1.732,0,0,1,.526,1.286v2.977h-.681v-.633c-.013.019-.033.045-.06.078a1.907,1.907,0,0,1-.182.176,1.95,1.95,0,0,1-.3.224,1.768,1.768,0,0,1-.426.174,1.969,1.969,0,0,1-.545.076,1.738,1.738,0,0,1-1.179-.414,1.231,1.231,0,0,1-.478-.948,1.292,1.292,0,0,1,.353-.945,1.786,1.786,0,0,1,1.014-.469Zm-.426,2.005a1.535,1.535,0,0,0,.426-1.124v-.3l-1.61.3q-.877.167-.881.828a.64.64,0,0,0,.26.521,1.116,1.116,0,0,0,.716.207A1.463,1.463,0,0,0,275.945,375.539Z",
    transform: "translate(-199.637 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-12",
    "data-name": "path",
    d: "M285.28,372.414h-.3a1.425,1.425,0,0,0-1.033.42,1.457,1.457,0,0,0-.429,1.091v2.586h-.681v-4.681h.681v.633c.013-.02.032-.046.057-.079a1.689,1.689,0,0,1,.181-.176,2.074,2.074,0,0,1,.307-.224,1.907,1.907,0,0,1,.438-.176,2.1,2.1,0,0,1,.578-.078h.2Z",
    transform: "translate(-202.017 -369.586)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-13",
    "data-name": "path",
    d: "M289.76,369.332a.448.448,0,1,1-.127.312A.423.423,0,0,1,289.76,369.332Zm-.026,1.874h.681v4.681h-.681Z",
    transform: "translate(-203.693 -368.963)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-14",
    "data-name": "path",
    d: "M295.481,369.788h.633v1.562h1.024v.633h-1.024v2.781q0,.733.633.728a1.3,1.3,0,0,0,.313-.038c.1-.026.182-.047.235-.067l.086-.038v.633a1.405,1.405,0,0,1-.662.142,1.245,1.245,0,0,1-.945-.355,1.393,1.393,0,0,1-.341-1.007v-2.781h-.881v-.633h.539c.261,0,.39-.162.39-.486Z",
    transform: "translate(-204.907 -369.107)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-15",
    "data-name": "path",
    d: "M302.031,374.415a1.611,1.611,0,0,0,.522,1.1,1.588,1.588,0,0,0,1.136.462,1.739,1.739,0,0,0,.814-.2,1.672,1.672,0,0,0,.533-.39l.166-.191.438.438c-.019.026-.047.062-.083.108a2.618,2.618,0,0,1-.238.234,2.562,2.562,0,0,1-.4.29,2.677,2.677,0,0,1-.548.234,2.248,2.248,0,0,1-.688.107,2.216,2.216,0,0,1-1.648-.712,2.512,2.512,0,0,1-.007-3.453,2.213,2.213,0,0,1,3.207-.047,2.316,2.316,0,0,1,.642,1.679l-.047.352Zm.539-1.615a1.706,1.706,0,0,0-.539,1.029H305.2a1.672,1.672,0,0,0-.511-1.048,1.47,1.47,0,0,0-1.051-.414A1.508,1.508,0,0,0,302.569,372.8Z",
    transform: "translate(-206.584 -369.586)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_name",
    "data-name": "logo name",
    transform: "translate(156.348 328.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-16",
    "data-name": "path",
    d: "M189.237,332.1v3.6h-9.7v4.117h7.571v3.6h-7.571v7.312h-4V332.1Z",
    transform: "translate(-175.536 -332.095)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-17",
    "data-name": "path",
    d: "M206.189,350.691a6.813,6.813,0,0,1-9.708,0,6.488,6.488,0,0,1,0-9.494,6.811,6.811,0,0,1,9.708,0,6.5,6.5,0,0,1,0,9.494Zm-7.1-2.286a3.037,3.037,0,0,0,4.494,0,3.659,3.659,0,0,0,0-4.915,3.024,3.024,0,0,0-4.494,0,3.661,3.661,0,0,0,0,4.915Z",
    transform: "translate(-180.195 -333.84)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-18",
    "data-name": "path",
    d: "M227.017,350.691a6.813,6.813,0,0,1-9.708,0,6.489,6.489,0,0,1,0-9.494,6.811,6.811,0,0,1,9.708,0,6.5,6.5,0,0,1,0,9.494Zm-7.1-2.286a3.037,3.037,0,0,0,4.494,0,3.661,3.661,0,0,0,0-4.915,3.024,3.024,0,0,0-4.494,0,3.659,3.659,0,0,0,0,4.915Z",
    transform: "translate(-185.335 -333.84)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-19",
    "data-name": "path",
    d: "M244.417,337.887a4.587,4.587,0,0,1,1.37.909l.4.481V332.1h3.584v18.623H246.19v-1.6a2.005,2.005,0,0,1-.163.2c-.073.082-.229.23-.468.441a5.244,5.244,0,0,1-.773.572,4.581,4.581,0,0,1-1.078.448,4.861,4.861,0,0,1-1.376.194,5.86,5.86,0,0,1-4.4-1.967,7.144,7.144,0,0,1,0-9.623,5.861,5.861,0,0,1,4.4-1.968A4.725,4.725,0,0,1,244.417,337.887Zm.838,8.9a4.029,4.029,0,0,0,0-5.163,3.04,3.04,0,0,0-4.519,0,4.029,4.029,0,0,0,0,5.163,3.027,3.027,0,0,0,4.519,0Z",
    transform: "translate(-190.475 -332.095)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-20",
    "data-name": "path",
    d: "M273.776,332.1v3.6h-9.7v4.117h7.571v3.6h-7.571v7.312h-4V332.1Z",
    transform: "translate(-196.398 -332.095)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-21",
    "data-name": "path",
    d: "M285.551,350.718h-3.6V332.1h3.6Z",
    transform: "translate(-201.798 -332.095)",
    fill: "#54000b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-22",
    "data-name": "path",
    d: "M294.421,352.418l-5.052-12.91H293.1l3.052,8.65,3.065-8.65h3.714l-5.181,13.831q-1.78,4.793-5.052,4.793a6.516,6.516,0,0,1-1.156-.1,5.162,5.162,0,0,1-.844-.208l-.26-.091v-3.182a3.022,3.022,0,0,0,1.325.26,2.274,2.274,0,0,0,2.26-1.468Z",
    transform: "translate(-203.628 -333.925)",
    fill: "#54000b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "main_logo",
    "data-name": "main logo",
    transform: "translate(97.781 319.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    "data-name": "path",
    d: "M141.107,340.591c.038,4.54-1.306,11.481-8.086,18.325-.021.021-.041.043-.06.066l-7.913,9.22-4.53,5.282a1.412,1.412,0,0,1-2.143,0l-10.547-12.294-.966-1.127h0l-.922-1.078c-.021-.025-.043-.048-.066-.072-.067-.068-.134-.137-.2-.2a46.849,46.849,0,0,1-5.709-8.34c-.371-.728-.591-1.241-.7-1.512-.016-.038-.028-.072-.038-.1-.032-.081-.047-.126-.047-.126a21.326,21.326,0,0,1-.68-13.178c5.089-16.533,20.952-16.386,20.952-16.386s15.861-.148,20.949,16.386c0,0,.016.041.038.123a.808.808,0,0,1,.029.088,18.344,18.344,0,0,1,.639,4.51C141.107,340.317,141.107,340.458,141.107,340.591Z",
    transform: "translate(-97.781 -319.066)",
    fill: "#e80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-24",
    "data-name": "path",
    d: "M138.115,351.093c-1.238.954-6.569,4.266-9.6,3.536a9.663,9.663,0,0,1-5.5-3.592s-.728,3.536-2.019,4.49c0,0,8.64.192,10.828,3.744a8.77,8.77,0,0,1,1.565,5.293l-7.632,8.9c.1-.189,4.786-8.977.57-10.977a8.878,8.878,0,0,0-5.5-1.067c-.221.026-.444.06-.671.1a40.821,40.821,0,0,0-6.958,2.037s-3.848,2.018-5.627,1.769h0l-.954-1.115c-.079-.078-.157-.16-.233-.24a46.806,46.806,0,0,1-5.709-8.34c1.055,1.338,6.014,6.886,11.682.966,0,0,4.433-3.759,1.741-10.942,0,0-4.827-.283-3.7,3.59l.9,4.937s-3.085,1.124-5.444-3.7c0,0-1.852-6.062,3.93-8.7a15.417,15.417,0,0,1,10.381-.954,4.959,4.959,0,0,1,4.43,3.366c1.011,3.255,2.471,5.655,4.6,5.633a23.3,23.3,0,0,0,5.555-1.2s1.628-.841,2.749,0a13.061,13.061,0,0,1,1.461,1.2S139.349,350.138,138.115,351.093Z",
    transform: "translate(-98.495 -324.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-25",
    "data-name": "path",
    cx: 4.631,
    cy: 4.631,
    r: 4.631,
    transform: "translate(21.297 6.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-26",
    "data-name": "path",
    d: "M150.959,345.141c0,.9-.047,1.511-.047,1.511h-13.2v-1.6h1.795a7.079,7.079,0,0,1,.224-2.469c1.234-4.1,5.529-4.04,5.529-4.04v-1.039h1.6v1.039a4.827,4.827,0,0,1,3.423,1.58.8.8,0,0,1,.029.088,18.343,18.343,0,0,1,.639,4.51C150.959,344.867,150.959,345.009,150.959,345.141Z",
    transform: "translate(-107.636 -323.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-27",
    "data-name": "path",
    d: "M141.514,345.592s.187-5.444,4.714-5.216a6.309,6.309,0,0,0-3.161,5.216Z",
    transform: "translate(-108.573 -324.323)",
    fill: "#b4091b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.adecf32343560932f85121d5809ef0d5.svg";
export { ForwardRef as ReactComponent };